export const Environment = {
  DEVELOPMENT: "development",
  PRODUCTION: "production",
  STAGING: "staging"
};

/**
 * Returns true if the current environment mode matches the specified mode.
 * @param {string} mode - The mode to check against the current environment mode.
 * @returns {boolean} - True if the current environment mode matches the specified mode, false otherwise.
 */
export const getEnvironment = (mode = Environment.DEVELOPMENT) =>
  import.meta.env.MODE === mode;
